import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchRequestBalance = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/fundTransfer/requests`,
      data: null, //force axios send headers content type
      params,
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchSingleRequest = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/fundTransfer/requests/${params.publicId}`,
      data: null, //force axios send headers content type
      params,
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};
